$.extend($.validator.messages, {
    required: "This field is required.",
    selectAValue: 'Please select a value.',
    selectEquipmentCategory: 'Please select at least one equipment category.'
});